import { useReaderEventHandler } from 'events/eventHandlers/ReaderEventHandler';
import { useUserEventHandler } from 'events/eventHandlers/UserEventHandler';
import { useInitializeActivity } from 'components/AppService/ActivityInitializer';

export const AppService = () => {
    useReaderEventHandler();
    useUserEventHandler();
    useInitializeActivity();
    return null;
};
